import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const newsLeverKeys = {
    switchContainer: generateAutomationName("settings", ["subscriptions", "news", "lever", "switch", "container"]),
    switchLabel: generateAutomationName("settings", ["subscriptions", "news", "lever", "switch", "label"]),
    radioGroupTitle: generateAutomationName("settings", ["subscriptions", "news", "lever", "radio", "group", "title"]),
    radioGroupGranularity: generateAutomationName("settings", [
        "subscriptions",
        "news",
        "lever",
        "granularity",
        "radio",
        "group",
        "container",
    ]),
};
